import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsAcomba } from '../../hooks/useIsAcomba';
import { useAcombaBridgeStore } from '../../stores/acombaBridgeStore';
import { isBridgeOutdated } from '../../utils/bridge/bridgeVersion';
import { TranslationKey } from '../../i18n/translationKeys';
import { Banner } from '../../ui/Banner/Banner';

/**
 * Non-blocking recommendation shown (Acomba only) when the connected bridge is older than the minimum
 * this app supports. The bridge ships with Acomba, so the fix is to update Acomba. Sync is refused
 * while outdated (see useSync / InitialSync / the incremental hook); this banner tells the user why.
 */
export const BridgeOutdatedBanner: React.FC = () => {
    const { t } = useTranslation();
    const isAcomba = useIsAcomba();
    const bridgeStatus = useAcombaBridgeStore((s) => s.bridgeStatus);
    const bridgeInfo = useAcombaBridgeStore((s) => s.bridgeInfo);

    if (!isAcomba) return null;
    if (bridgeStatus !== 'reachable') return null;
    if (!isBridgeOutdated(bridgeInfo?.bridgeVersion)) return null;

    return (
        <Banner tone="warning" testId="bridge-outdated-banner" className="mb-l">
            {t(TranslationKey.AcombaBridge.BridgeOutdated.BannerMessage)}
        </Banner>
    );
};
